"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./postAvatar.request"), exports);
(0, tslib_1.__exportStar)(require("./center.request"), exports);
//# sourceMappingURL=index.js.map